module.exports = __webpack_public_path__ + "img/notepad.17fd7fc6.svg";